import leftTop from '@images/left-top.svg';
import leftBottom from '@images/left-bottom.svg';
import rightTop from '@images/right-top.svg';
import rightBottom from '@images/right-bottom.svg';

export const mapping = {
  'left-top': leftTop,
  'left-bottom': leftBottom,
  'right-top': rightTop,
  'right-bottom': rightBottom,
};
